import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "desc",
  "data-tags": "0"
};
const _hoisted_3 = {
  class: "button-group"
};
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
// import { useConfiguratorStore } from "@/stores/configuratorData";
// import { openFullLoading } from "@/utils/tools";
import { onMounted, ref } from "vue";
import { useLoaderStore } from "@/stores/loaderState";
// const { t } = i18n.global;
export default /*@__PURE__*/_defineComponent({
  __name: 'productSummaryPromo',
  setup(__props) {
    // import i18n from "@/lang";
    const promoSection = ref(false);
    const imageUrl = ref("");
    const openPromoLink = () => {
      window.open(useAdditionalAttrStore().dataConfig.linkTarget, "_blank");
    };
    const hidePromo = () => {
      localStorage.setItem("promoSection", "hide");
      useLoaderStore().setPromoSectionLoading(false);
    };
    const closePromo = () => {
      useLoaderStore().setPromoSectionLoading(false);
    };
    onMounted(() => {
      imageUrl.value = useAdditionalAttrStore().dataConfig.promoSectionBannerImageUrl ?? "";
      if (useAdditionalAttrStore().dataConfig.promoSectionEnabled == true && localStorage.getItem("promoSection") !== "hide") {
        setTimeout(() => {
          promoSection.value = true;
        }, 30000);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createBlock(_Transition, {
        name: "slide"
      }, {
        default: _withCtx(() => [_unref(useLoaderStore)().promoSection && _unref(useAdditionalAttrStore)().dataConfig.promoSectionEnabled ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(imageUrl.value ? {
            backgroundImage: `url(${imageUrl.value})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          } : {}),
          class: "product-products-promo"
        }, [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 2
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("i", {
              class: "iconfont icon-info"
            }, null, -1)]))]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 19
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("label.promoTitle")), 1), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("label.promoDesc")), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
              onClick: openPromoLink,
              class: "wikaButtonConf",
              "data-colour": "blue",
              id: "promoButton"
            }, _toDisplayString(_ctx.$t("label.promoButton")), 1), _createElementVNode("div", {
              onClick: hidePromo,
              id: "promoClose",
              class: "wikaButtonConf",
              "data-colour": "white"
            }, _toDisplayString(_ctx.$t("label.promoclose")), 1)])])]),
            _: 1
          }), _createVNode(_component_el_col, {
            onClick: closePromo,
            span: 1
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("i", {
              class: "iconfont icon-close"
            }, null, -1)]))]),
            _: 1
          })]),
          _: 1
        })], 4)) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
});